import { render, staticRenderFns } from "./ModalSalaryPackagingProviderEdit.vue?vue&type=template&id=60c247bc&"
import script from "./ModalSalaryPackagingProviderEdit.vue?vue&type=script&lang=js&"
export * from "./ModalSalaryPackagingProviderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports